import React, { useEffect } from 'react';
import { IResponse } from 'src/interface';
import { ArrayUtils } from 'src/utils';
import { useAsyncFn } from 'src/hooks';
import { Element } from 'src/components';
import { renderSections } from 'src/modules/shared/components/sections';
import { Loader } from '@zmedia/bm-common/components/loader';
import ContentService from 'src/services/ContentService';
import styles from './style.module.scss';
import { SECTION_ID } from 'src/constants';
import { ContentRelatedSection } from './ContentRelated';
import { ZShortSection } from 'src/modules/event/zshort';

interface IProps {
    contentId: number;
    related?: any;
    isBot?: boolean;
}

const SECTION_MAP = {
    [SECTION_ID.CONTENT]: ContentRelatedSection,
    [SECTION_ID.ZSHORT]: ZShortSection,
};

export default React.memo(function ContentsRelated({
    contentId,
    related = [],
    isBot = false,
}: IProps) {
    const [state, callback] = useAsyncFn<IResponse<any>>(
        ContentService.getListRelated,
    );

    useEffect(() => {
        if (contentId > 0 && ArrayUtils.isEmpty(related)) {
            callback(contentId);
        }
    }, [contentId]);

    if (state.loading) {
        return <Loader />;
    }

    let data = ArrayUtils.isEmpty(related) ? state.value?.data : related || [];

    data = data?.map((item: any) => ({
        ...item,
        contentId,
    }));

    return (
        <Element className={styles['contents-related']}>
            {renderSections(data, SECTION_MAP, isBot)}
        </Element>
    );
});
